var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 45,
    viewBox: "0 0 24 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_245)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_134_245)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.565959 0.698249C0.724296 0.540421 0.912395 0.415202 1.11948 0.329764C1.32657 0.244327 1.54857 0.200348 1.77278 0.200348C1.99698 0.200348 2.21899 0.244327 2.42607 0.329764C2.63316 0.415202 2.82126 0.540421 2.9796 0.698249L23.4341 21.0354C23.5929 21.1928 23.7188 21.3799 23.8048 21.5858C23.8907 21.7917 23.9349 22.0124 23.9349 22.2353C23.9349 22.4582 23.8907 22.6789 23.8048 22.8848C23.7188 23.0907 23.5929 23.2778 23.4341 23.4352L2.9796 43.7724C2.65953 44.0906 2.22542 44.2694 1.77278 44.2694C1.32013 44.2694 0.886027 44.0906 0.565959 43.7724C0.245891 43.4541 0.066078 43.0225 0.066078 42.5725C0.066078 42.1224 0.245891 41.6908 0.565959 41.3726L19.8171 22.2353L0.565959 3.09803C0.407221 2.9406 0.281279 2.75359 0.195347 2.54769C0.109416 2.34179 0.0651855 2.12106 0.0651855 1.89814C0.0651855 1.67522 0.109416 1.45449 0.195347 1.24859C0.281279 1.0427 0.407221 0.855677 0.565959 0.698249Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 44.4706,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_134_245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 44.4706,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/ChevronRight.dc893ae11b4830cc2629641c97fb8537.svg";
export { ForwardRef as ReactComponent };